export const EXSBITEMBRAND_DELETE_RESET = 'EXSBITEMBRAND_DELETE_RESET'
export const EXSBITEMBRAND_DELETE_SET_ERROR = 'EXSBITEMBRAND_DELETE_SET_ERROR'
export const EXSBITEMBRAND_DELETE_SET_DELETED = 'EXSBITEMBRAND_DELETE_SET_DELETED'
export const EXSBITEMBRAND_DELETE_TOGGLE_LOADING = 'EXSBITEMBRAND_DELETE_TOGGLE_LOADING'
